import { createFileRoute } from '@tanstack/react-router';

import { SupplierContactsImporterPage } from '@/areas/suppliers/Suppliers/SupplierContactsImporterPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/suppliers/$supplierId/supplier-contacts/importer')({
    // No `create:supplier`, which the importer for all suppliers needs: the "Manually" entry next to the link here
    // adds contacts without it.
    staticData: { access: { permissions: ['view:supplier'] }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <SupplierContactsImporterPage {...pathParams} />;
}
